import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Chip,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import { useSelector } from "react-redux";
import ReusableDialog from "../../../../common/dialog/dialog";
import BodyMapBoy from "../BodyMapSafeGuarding/body-map-boy";
import BodyMapGirl from "../BodyMapSafeGuarding/body-map-girl";

const NonPhysicalIncident = ({ updateFormData, prevStep, handleSubmit, formData, category }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store
  const [incidentCategory, setIncidentCategory] = useState(category || "No");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [medicalData, setMedicalData] = useState([]);
  const [bodyMapOpen, setBodyMapOpen] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState("");
  const [uploadedImages, setUploadedImages] = useState([]); // State to store records

  useEffect(() => {
    if (formData && formData.length > 0) {
      setMedicalData(formData);
    }
  }, [formData]);

  // Handle Category Change
  const handleCategoryChange = (event) => {
    setIncidentCategory(event.target.value);
    updateFormData({
      incidentCategory: event.target.value,
    });
  };

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Non - Physical Intervention</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      {/* Incident Category */}
      <Typography sx={{ fontSize: "14px", fontWeight: "bold", mb: 2 }}>
        Did the young person sustain any injuries ?*
      </Typography>
      <FormControl component='fieldset' ml={2}>
        <RadioGroup row value={incidentCategory} onChange={handleCategoryChange}>
          <FormControlLabel
            onClick={() => setDialogOpen(true)}
            value='Yes'
            control={<Radio sx={{ color: "#007AFF" }} />}
            label={
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "black" }}>YES</Typography>
                <Typography sx={{ fontSize: "12px", color: "#A0A0A0" }}>Show them in the body map</Typography>
              </Box>
            }
            sx={{
              borderRadius: "10px",
              padding: "10px 15px",
              border: "1px solid #007AFF",
              width: "fit-content",
            }}
          />
          <FormControlLabel
            value='No'
            control={<Radio sx={{ color: "#007AFF" }} />}
            label={
              <Box>
                <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "black" }}>No</Typography>
                <Typography sx={{ fontSize: "12px", color: "#A0A0A0" }}>There is no injuries happed</Typography>
              </Box>
            }
            sx={{
              borderRadius: "10px",
              padding: "10px 15px",
              border: "1px solid #007AFF",
              width: "fit-content",
            }}
          />
        </RadioGroup>
      </FormControl>

      <ReusableDialog
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSubmit={() => {
          setBodyMapOpen(true);
          setDialogOpen(false);
        }}
        submitText='Submit'
        cancelText='Cancel'
      >
        <Box>
          <Chip
            variant='contained'
            sx={{
              fontSize: "14px",
              backgroundColor: "#F2F6FF",
              color: "blue",
            }}
            label='Daily Log'
            size='small'
          />
          <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Body Skin Map</Typography>
          <Typography variant='subtitle2' sx={{ color: "#757575" }}>
            Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
            <span style={{ color: "#1751D0" }}>{user.username}</span>
          </Typography>
          <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />
          <Typography sx={{ mb: 2 }}>Select the Injured person</Typography>

          <TextField
            select
            fullWidth
            placeholder='Enter the name'
            variant='outlined'
            value={selectedPerson}
            onChange={(e) => setSelectedPerson(e.target.value)}
            sx={{ mb: 3 }}
          >
            <MenuItem value='Male'>Male</MenuItem>
            <MenuItem value='Female'>Female</MenuItem>
          </TextField>
        </Box>
      </ReusableDialog>

      <ReusableDialog
        isOpen={bodyMapOpen}
        onClose={() => setBodyMapOpen(false)}
        onSubmit={() => {
          setBodyMapOpen(false);
          updateFormData({
            nonPhysicalIncidentInfo: incidentCategory === "Yes" ? medicalData : [],
            gender: selectedPerson,
            uploadedImages,
          });
        }}
        submitText='Submit'
        cancelText='Cancel'
        maxWidth='lg'
      >
        {selectedPerson === "Male" ? (
          <BodyMapBoy medicalData={medicalData} setMedicalData={setMedicalData} setUploadedImages={setUploadedImages} />
        ) : selectedPerson === "Female" ? (
          <BodyMapGirl
            medicalData={medicalData}
            setMedicalData={setMedicalData}
            setUploadedImages={setUploadedImages}
          />
        ) : (
          <></>
        )}
      </ReusableDialog>
      {/* Footer Actions */}
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
          display: "flex",
          gap: 2,
        }}
      >
        <Button
          variant='outlined'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            prevStep();
          }}
        >
          Previous
        </Button>

        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            window.scrollTo(0, 0); // Prevent scrolling
            handleSubmit();
          }}
          disabled={!incidentCategory}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default NonPhysicalIncident;
